module.exports = new __parcel__URL__("pokmon-leafgreen.91184c5d.jpg").toString();